export default "__VITE_ASSET__ad62917b__"